<div
  [ngClass]="{blackshield:isPopinDeployed }">
</div>
<div [ngClass]="{extend:isPopinDeployed, retract:!isPopinDeployed }" class="bottom-popin-container {{theme}}">
  <ng-content></ng-content>
</div>
